import React, { useState } from "react";
import '../../../css/partner/PartnerNotifications.css';
import ToolSidebar from "../../utils/ToolSideBar";
import {
  categoryLabel,
  getNotificationCategories,
  notificationMatchesCategory,
  notificationTypeLabel,
} from "../../utils/notificationCategories";

export default function PartnerNotifications({ notifications, markAllAsRead, openNotification }) {
    const [filter, setFilter] = useState("all");
    const empty = notifications.length === 0;
    const categories = getNotificationCategories(notifications);
    const selectedLabel = categoryLabel(categories, filter);
  
  
  const filtered = notifications.filter((n) => notificationMatchesCategory(n, filter));
  const emptyTitle = empty ? "You're all caught up" : `No ${selectedLabel.toLowerCase()} notifications`;
  const emptyMessage = empty
    ? "New messages, project alerts, referrals, and commission updates will appear here."
    : filter === "unread"
      ? "Everything in your notification center has been read."
      : "Updates in this category will appear here when they arrive.";

  return (
    <div className="notifications-shell">

      {/* SIDEBAR */}
      <ToolSidebar active="notifications" />

      {/* MAIN */}
      <div className="notifications-page">

        {/* HEADER */}
        <div className="notifications-header">
          <span className="notifications-eyebrow">SCD ACTIVITY</span>
          <h1>Notifications</h1>
          <p>Your latest updates, requests, and project activity.</p>
        </div>

        {/* FILTERS + ACTIONS */}
        <div className="notifications-toolbar">
          <div className="notification-filters" role="tablist" aria-label="Notification categories">
            {categories.map((category) => (
              <button
                key={category.key}
                type="button"
                role="tab"
                aria-selected={filter === category.key}
                className={filter === category.key ? "active" : ""}
                onClick={() => setFilter(category.key)}
              >
                {category.label}
              </button>
            ))}
          </div>

          <label className="notification-filter-select">
            <span>Show</span>
            <select value={filter} onChange={(event) => setFilter(event.target.value)}>
              {categories.map((category) => (
                <option key={category.key} value={category.key}>{category.label}</option>
              ))}
            </select>
          </label>

          <button className="mark-all-btn" onClick={markAllAsRead}>
            Mark all as read
          </button>
        </div>

        {/* LIST */}
        <div className="notification-list">
          {empty || filtered.length === 0 ? (
            <section className="notification-empty" aria-live="polite">
              <h2>{emptyTitle}</h2>
              <p>{emptyMessage}</p>
            </section>
          ) : (
             filtered.map((n) => (
                <div
                    key={n.id}
                    className={`notification-card ${n.read ? "read" : "unread"}`}
                    role={n.path ? "button" : undefined}
                    tabIndex={n.path ? 0 : undefined}
                    onClick={() => openNotification?.(n)}
                    onKeyDown={(event) => {
                      if (n.path && (event.key === "Enter" || event.key === " ")) {
                        event.preventDefault();
                        openNotification?.(n);
                      }
                    }}
                >
                    <div className="notification-dot" />

                    <div className="notification-content">
                    <h3>{n.title}</h3>
                    {n.message && <p>{n.message}</p>}

                    <span className="notification-meta">
                        {new Date(n.created_at).toLocaleString()}
                    </span>
                    </div>

                    <div className={`badge type-${n.notification_type || n.type}`}>
                    {notificationTypeLabel(n)}
                    </div>
                </div>
                ))
          )}
        </div>

      </div>
    </div>
  );
}